import { connect, Dispatch } from 'react-redux';
import { Main, ConnectedProps, ActionProps } from './component';
import { DeleteAlertAction } from './actions';
import { AppState } from 'pages/app/state';
import { Action } from 'helpers/action-helpers';

function mapStateToProps({ main, menu, scanner, login, notifications }: AppState): ConnectedProps {
  return {
    username: login.username,
    alerts: main.alerts,
    notification: notifications.visibleNotification,
    isManualInputHidden: main.isManualInputHidden,
    isScannerEnabled: scanner.isEnabled,
  };
}

function mapDisptachToProps(dispatch: Dispatch<Action>): ActionProps {
  return {
    closeAlert: (clientTransactionId: string, username: string) => dispatch(new DeleteAlertAction(clientTransactionId, username))
  };
}

export default connect(mapStateToProps, mapDisptachToProps)(Main);



// WEBPACK FOOTER //
// ./src/components/main/index.ts